const FORGOT_PASSWORD_USERNAME_KEY = "msuite_forgot_password_username";

/**
 * Persist the login username so Forgot Password can prefill it, and so login
 * can restore it after returning from Forgot Password.
 * Uses sessionStorage (no shared app state between login and forgot-password views).
 */
export function setForgotPasswordUsername(username) {
  const value = (username ?? "").trim();
  if (!value) {
    sessionStorage.removeItem(FORGOT_PASSWORD_USERNAME_KEY);
    return;
  }
  sessionStorage.setItem(FORGOT_PASSWORD_USERNAME_KEY, value);
}

/** Non-destructive read of the carried-over username. */
export function getForgotPasswordUsername() {
  return sessionStorage.getItem(FORGOT_PASSWORD_USERNAME_KEY) ?? "";
}

/** Read and clear the carried-over username (one-shot restore on login remount). */
export function takeForgotPasswordUsername() {
  const value = getForgotPasswordUsername();
  sessionStorage.removeItem(FORGOT_PASSWORD_USERNAME_KEY);
  return value;
}
